import { render } from "./comIndex.vue?vue&type=template&id=8f460846&scoped=true"
import script from "./comIndex.vue?vue&type=script&lang=js"
export * from "./comIndex.vue?vue&type=script&lang=js"

import "./comIndex.vue?vue&type=style&index=0&id=8f460846&lang=less&scoped=true"

import exportComponent from "/root/workspace/service-web_SY5C/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f460846"]])

export default __exports__